import { useLocation } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import LinkButton from '@rewardopl/react-ui/link_button';

import { ButtonWrapper } from './index.styles';

import LoginWithGoogleButton from './login_with_google_button';

export default function LoginMain() {
  const location = useLocation();

  const { state } = location;

  return (
    <ButtonWrapper>
      <LoginWithGoogleButton />
      <LinkButton className="primary" state={state} to="email">
        <T>Login with email</T>
      </LinkButton>
    </ButtonWrapper>
  );
}
